import { observer } from 'mobx-react-lite'
import { type TxfJobCardViewModel } from '@/features/jobs/details/components/TxfJobCard/TxfJobCardViewModel'
import { TxfButton } from '@/features/jobs/details/components/TxfButton'

export interface TxfButtonContainerProps {
  vm: TxfJobCardViewModel
}

export const TxfButtonContainer = observer(function TxfButtonContainer({
  vm,
}: TxfButtonContainerProps) {
  return <TxfButton onPress={vm.viewInTxf} />
})
